import { defaultLogState } from './module-log-state';

export default {
	resetState(state) {
		Object.assign(state, defaultLogState);
	},
	updateAccessLogData: function(state, res) {
		state.AccessLogData.removeAll();
		state.AccessLogData.append(res.Data);
		state.Total = res.Total;
	},
	updateQuickSearchText(state, text) {
		state.CachedQuickSearchText = text;
	},
	updateCondition(state, payload) {
		state.CachedFilterOptions = {
			FromDate: payload.FromDate,
			ToDate: payload.ToDate
		};
	}
};
